import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { isVideoAlbum } from '../../../../util/album';

const propTypes = {
  uploadedTargets: PropTypes.array.isRequired,
};

const SpecialtyEventUploadFinishMessage = ({ uploadedTargets }) => {
  const isVideoAlbumBool = isVideoAlbum(uploadedTargets[0]);

  return (
    <p className="text-light text-center mb-0">
      {uploadedTargets.length === 1 ? (
        <Fragment>
          Your {isVideoAlbumBool ? 'message has' : 'photos have'} been added!
        </Fragment>
      ) : (
        <Fragment>Your photos and message have been added!</Fragment>
      )}
    </p>
  );
};

SpecialtyEventUploadFinishMessage.propTypes = propTypes;

export default SpecialtyEventUploadFinishMessage;
